var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{style:(_vm.cssProps)},[_c('router-view'),_c('ProductFruits'),_c('appcues'),_c('base-snackbar'),_c('animation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }